import Image, { ImageProps } from "next/image";
import {
  CSSProperties,
  FC,
  memo,
  MouseEventHandler,
  useEffect,
  useState,
} from "react";

import { getImageProperty, ImageProperty } from "@/utils/common";

interface Props {
  src: string;
  width?: number;
  height?: number;
  alt?: string;
  className?: string;
  style?: CSSProperties;
  imageNodeProps?: ImageProps; // ImageNode固有のprops
  onChangeImageProps?: (image: ImageProperty) => void;
  onClick?: MouseEventHandler<HTMLImageElement>;
}

/**
 * srcを指定するだけで画像を読み込む
 * @param className
 * @constructor
 */
const ImgBase: FC<Props> = ({
  src,
  width,
  height,
  alt = "",
  className = "",
  style = {},
  imageNodeProps,
  onChangeImageProps,
  onClick,
}) => {
  const [imgProp, setImgProp] = useState<ImageProperty>();

  useEffect(() => {
    // 画像を読み込む
    getImageProperty(src)
      .then((result) => {
        const numWidth = Number(width);
        const ratio = numWidth ? numWidth / result.width : 1;
        const ratioWidth = Math.floor(result.width * ratio);
        const ratioHeight = Math.floor(result.height * ratio);
        const imgProp = {
          src: result.src,
          width: ratioWidth,
          height: ratioHeight,
        };
        setImgProp(imgProp);

        onChangeImageProps && onChangeImageProps(imgProp);
      })
      .catch(() => {
        setImgProp(undefined);
      });
  }, [src, width]);

  return (
    <>
      {imgProp && (
        <Image
          src={src}
          width={width ? width : imgProp.width}
          height={height ? height : imgProp.height}
          alt={alt}
          className={className}
          style={style}
          layout={imageNodeProps?.layout}
          loader={imageNodeProps?.loader}
          quality={imageNodeProps?.quality}
          loading={imageNodeProps?.loading}
          lazyRoot={imageNodeProps?.lazyRoot}
          lazyBoundary={imageNodeProps?.lazyBoundary}
          placeholder={imageNodeProps?.placeholder}
          blurDataURL={imageNodeProps?.blurDataURL}
          unoptimized={imageNodeProps?.unoptimized}
          objectFit={imageNodeProps?.objectFit}
          objectPosition={imageNodeProps?.objectPosition}
          onLoadingComplete={imageNodeProps?.onLoadingComplete}
          onClick={onClick}
        />
      )}
    </>
  );
};

export const Img = memo(ImgBase);
